import {Utils} from '../../common/scripts/utils';

const introMain = document.querySelector('.j-intro-main');

const setHeight = () => {
    if (Utils.getWindowWidth() < 1279.95 && introMain) {
        // introMain.style.height = `${window.innerHeight}px`;
    }
};


setHeight();

window.addEventListener('resize', () => {
    setHeight();
});
